<template>
  <div>
    <div class="modalUser">
      <b-modal id="modalUploadFile" static ref="modalUploadFile" modal-class="modal-custom modal-upload modal-radius modal-search top-mb" centered size="lg" no-close-on-backdrop>
        <template v-slot:modal-header="{ close }">
          <!-- Emulate built in modal header close button action -->
          <div class="title-modal text-center w-100">
            <h2 class="title text-uppercase">ファイル検索</h2>
            <div class="btn-closeModal" @click="hideModal">
              <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
            </div>
          </div>
        </template>
        <div class="modalUser--main" :class="{'chrome': checkChrome, 'firefox': checkFirefox }">
          <ul class="d-flex justify-content-center">
            <li>
              <div class="form-group fileType typePdf">
                <input type="checkbox" id="filePdf" name="filePdf" v-model="media_type_ids" class="input-pdf" value="2">
                <label class="label" for="filePdf">
                  <div class="d-flex choose-file pdf">
                    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49">
                      <g id="Group_11516" data-name="Group 11516" transform="translate(12748 -4354.5)">
                        <circle id="Ellipse_157" data-name="Ellipse 157" cx="24.5" cy="24.5" r="24.5" transform="translate(-12748 4354.5)" fill="#e8efe7"/>
                        <path id="Icon_metro-file-pdf" data-name="Icon metro-file-pdf" d="M23.051,7.5a3.246,3.246,0,0,1,.67,1.06A3.22,3.22,0,0,1,24,9.793V25.864A1.334,1.334,0,0,1,22.66,27.2H3.91a1.334,1.334,0,0,1-1.339-1.339V3.543A1.334,1.334,0,0,1,3.91,2.2h12.5a3.221,3.221,0,0,1,1.228.279,3.246,3.246,0,0,1,1.06.67ZM16.856,4.1V9.346H22.1a1.524,1.524,0,0,0-.307-.572L17.428,4.408a1.524,1.524,0,0,0-.572-.307Zm5.357,21.317V11.132h-5.8a1.334,1.334,0,0,1-1.339-1.339v-5.8H4.356V25.418H22.214Zm-7.171-8.273a10.615,10.615,0,0,0,1.172.781,13.844,13.844,0,0,1,1.632-.1q2.051,0,2.469.684a.674.674,0,0,1,.028.725.04.04,0,0,1-.014.028l-.028.028v.014q-.084.53-.99.53a5.755,5.755,0,0,1-1.6-.279,10.173,10.173,0,0,1-1.814-.739,25.121,25.121,0,0,0-5.469,1.158q-2.134,3.655-3.376,3.655a.811.811,0,0,1-.391-.1l-.335-.167q-.014-.014-.084-.07a.577.577,0,0,1-.084-.5,3.03,3.03,0,0,1,.781-1.277,6.742,6.742,0,0,1,1.842-1.346.2.2,0,0,1,.321.084.08.08,0,0,1,.028.056q.725-1.186,1.493-2.748a21.293,21.293,0,0,0,1.451-3.655,11.277,11.277,0,0,1-.426-2.225A5.424,5.424,0,0,1,11.736,9.9q.153-.558.586-.558h.307a.588.588,0,0,1,.488.209,1.114,1.114,0,0,1,.126.949.3.3,0,0,1-.056.112.363.363,0,0,1,.014.112v.419a18.269,18.269,0,0,1-.2,2.679,7.058,7.058,0,0,0,2.037,3.32ZM7.007,22.879a6.16,6.16,0,0,0,1.911-2.2A7.953,7.953,0,0,0,7.7,21.846,4.637,4.637,0,0,0,7.007,22.879ZM12.56,10.044a4.148,4.148,0,0,0-.028,1.842q.014-.1.1-.614,0-.042.1-.6a.314.314,0,0,1,.056-.112.04.04,0,0,1-.014-.028.028.028,0,0,0-.007-.021.028.028,0,0,1-.007-.021.8.8,0,0,0-.181-.5.04.04,0,0,1-.014.028v.028Zm-1.73,9.222a20.463,20.463,0,0,1,3.962-1.13A2.1,2.1,0,0,1,14.61,18a2.5,2.5,0,0,1-.223-.188,7.39,7.39,0,0,1-1.772-2.455,18.643,18.643,0,0,1-1.158,2.748q-.419.781-.628,1.158Zm9.012-.223a3.339,3.339,0,0,0-1.953-.335,5.277,5.277,0,0,0,1.73.391,1.353,1.353,0,0,0,.251-.014q0-.014-.028-.042Z" transform="translate(-12736.811 4364.296)" fill="#a9b0b1"/>
                      </g>
                    </svg>
                    <div class="name-type">PDF</div>
                  </div>
                </label>
              </div>
            </li>
            <li>
              <div class="form-group fileType typeImage">
                <input type="checkbox" id="fileImage" name="fileImage" class="input-image" v-model="media_type_ids" value="3">
                <label class="label" for="fileImage">
                  <div class="d-flex choose-file image">
                    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49">
                      <g id="Group_11503" data-name="Group 11503" transform="translate(-624 -169)">
                        <circle id="Ellipse_158" data-name="Ellipse 158" cx="24.5" cy="24.5" r="24.5" transform="translate(624 169)" fill="#e8efe7"/>
                        <path id="Icon_metro-file-image" data-name="Icon metro-file-image" d="M23.051,7.5a3.246,3.246,0,0,1,.67,1.06A3.22,3.22,0,0,1,24,9.793V25.864A1.334,1.334,0,0,1,22.66,27.2H3.91a1.334,1.334,0,0,1-1.339-1.339V3.543A1.334,1.334,0,0,1,3.91,2.2h12.5a3.221,3.221,0,0,1,1.228.279,3.246,3.246,0,0,1,1.06.67ZM16.856,4.1V9.346H22.1a1.524,1.524,0,0,0-.307-.572L17.428,4.408a1.524,1.524,0,0,0-.572-.307Zm5.357,21.317V11.132h-5.8a1.334,1.334,0,0,1-1.339-1.339v-5.8H4.356V25.418H22.214Zm-1.786-6.25v4.464H6.142V20.953l2.679-2.679,1.786,1.786L15.964,14.7ZM8.821,16.489a2.667,2.667,0,0,1-2.679-2.679,2.667,2.667,0,0,1,2.679-2.679A2.667,2.667,0,0,1,11.5,13.811a2.667,2.667,0,0,1-2.679,2.679Z" transform="translate(635.338 178.796)" fill="#a9b0b1"/>
                      </g>
                    </svg>
                    <div class="name-type">画像</div>
                  </div>
                </label>
              </div>
            </li>
            <li>
              <div class="form-group fileType typeVideo">
                <input type="checkbox" id="fileVideo" name="fileVideo" class="input-video" v-model="media_type_ids" value="4">
                <label class="label" for="fileVideo">
                  <div class="d-flex choose-file video">
                    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49">
                      <g id="Group_11522" data-name="Group 11522" transform="translate(-814 -218)">
                        <circle id="Ellipse_159" data-name="Ellipse 159" cx="24.5" cy="24.5" r="24.5" transform="translate(814 218)" fill="#e8efe7"/>
                        <path id="Icon_metro-file-video" data-name="Icon metro-file-video" d="M24.824,7.521a21.976,21.976,0,0,0-2.075-2.434,21.763,21.763,0,0,0-2.373-2.128c-1.228-.923-1.823-1.03-2.164-1.03H6.4A1.931,1.931,0,0,0,4.5,3.881V24.975a1.931,1.931,0,0,0,1.9,1.953H23.924a1.931,1.931,0,0,0,1.9-1.953V9.741a3.946,3.946,0,0,0-1-2.22ZM21.671,6.191A21.146,21.146,0,0,1,23.4,8.178H19.734V4.42a20.949,20.949,0,0,1,1.937,1.772ZM24.3,24.975a.391.391,0,0,1-.381.391H6.4a.391.391,0,0,1-.381-.391V3.881A.391.391,0,0,1,6.4,3.491H18.21V8.959a.772.772,0,0,0,.762.781H24.3ZM9.069,14.428h7.618v7.813H9.069V14.428Zm7.618,3.125,4.571-3.125v7.813l-4.571-3.125Z" transform="translate(823.509 228.474)" fill="#a9b0b1"/>
                      </g>
                    </svg>
                    <div class="name-type">動画</div>
                  </div>
                </label>
              </div>
            </li>
          </ul>
          <form action="">
            <label for="name" class="vendor__label mt-15">ファイル名</label>
            <input type="text" name="" id="name" class="input-form" placeholder="ファイル名を入力してください" v-model="file_name">
            <b-row>
              <b-col cols="12" lg="6">
                <label class="vendor__label mt-15">更新期間</label>
                <div class="d-flex justify-content-between align-items-center">
                  <el-date-picker
                    v-model="start_date"
                    type="date"
                    class="width-date"
                    format="yyyy/MM/dd"
                    value-format="yyyy/MM/dd"
                    placeholder="開始日">
                  </el-date-picker>
                  <span class="vendor__spaceIP">-</span>
                  <el-date-picker
                    v-model="end_date"
                    type="date"
                    class="width-date"
                    format="yyyy/MM/dd"
                    value-format="yyyy/MM/dd"
                    placeholder="終了日">
                  </el-date-picker>
                </div>
                <small class="w-100 error-datetime">{{errorDateStart}}</small>
              </b-col>
              <b-col cols="12" lg="6">
                <label class="vendor__label mt-15">作成者</label>
                <div class="input-group">
                  <el-select v-model="author_id" placeholder="選択" class="w-100 select-author-search">
                    <el-option v-for="(list,index) in listAuthor" :key="index" :label="truncate(list.name,10,'...')" :value="list.id">
                    </el-option>
                  </el-select>
                </div>
              </b-col>
            </b-row>
            <label class="vendor__label mt-15">フォルダ名</label>
            <div class="input-group s-list">
              <div v-on:click="showListFolder" class="choose-folder" :class="{chooseName: folder_name}" >{{folder_name? folder_name: 'フォルダ名を選択してください'}}</div>
              <div v-if="isHidden" class="s-list-folder">
                <div class="folder-back">
                  <div class="folder-list">
                    <div>
                      <img src="@img/icon/left-arrow.svg" alt="" class="img-sign" v-if="metadataMove.folder_name" @click="backFolder(metadataMove.folder_parent_id)">
                      <span>{{metadataMove.folder_name ? metadataMove.folder_name : 'ファイル一覧'}}</span>
                    </div>
                  </div>
                </div>
                <ul class="folder-move l-folder-scroll scroll-bar">
                  <li class="folder-li" v-for="(folder,index) in folderMove" :key="index" @dblclick="openFolder(folder.id)">
                    <div class="folder-list">
                      <div>
                        <img src="@img/folder.svg" alt="" class="img-sign">
                        <span>{{folder.name}} </span>
                      </div>
                      <img src="@img/icon/icon-down-grey.svg" class="img-next" @click="openFolder(folder.id)"/>
                    </div>
                  </li>
                </ul>
                <div class="btn-folder">
                  <button class="btn-primary btn-select-folder" type="button" @click="selectFolder">選択</button>
                </div>
              </div>
            </div>
            <label for="tags" class="vendor__label mt-15">タグ</label>
            <multiselect id="tags"
                         ref="multiselect"
                         class="tags-search"
                         @open="closeAutocomplete"
                         :value="tag" tag-placeholder="選択するように押してください"
                         placeholder="タグを入力してください" label="name"
                         :options="listTags" :hide-selected="true" @remove="closeTags"
                         :multiple="true" :taggable="true" track-by="name"
                         @select="onSelect"
                         selectLabel="選択するように押してください"
                         @search-change="getTag" @tag="addTag">
              <span slot="noOptions"></span>
              <span slot="noResult">タグが既に存在しています</span>
            </multiselect>
          </form>
        </div>
        <template v-slot:modal-footer>
          <div class="w-100">
            <div class="d-flex mypage__btnGroup justify-content-center btn-reverse">
              <button
                class="btn btn-rounder btn-secondary btn-contact w-100 btn-basic mr-30"
                type="button" @click="clearData">クリア</button>
              <button
                class="btn btn-rounder btn-primary btn-contact w-100 btn-basic"
                type="button" @click="searchFile">検索</button>
            </div>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import Multiselect from 'vue-multiselect'
import {mapState} from 'vuex'
import _ from 'lodash'
import {MEDIA_TYPE} from '@/utils/constant'
import 'element-ui/lib/theme-chalk/index.css'
import { setDragAndDrop } from '@/utils/common'

export default {
  name: 'Search_file',
  data () {
    return {
      isHidden: false,
      start_date: '',
      end_date: '',
      tag: [],
      tags: [],
      file_name: '',
      author_id: '',
      folder_parent_id: '',
      folder_name: '',
      media_type_ids: [],
      media_type: MEDIA_TYPE,
      errorDateStart: '',
      errorDateEnd: '',
      idSelect: '',
      query: {},
      checkChrome: false,
      checkFirefox: false
    }
  },
  watch: {
    'start_date' () {
      if (this.start_date === 'null') {
        this.start_date = ''
      }
      if (this.end_date) {
        if (new Date(this.start_date).getTime() > new Date(this.end_date).getTime()) {
          this.errorDateStart = '開始日は終了日より前である必要があります'
        } else {
          this.errorDateStart = ''
        }
      } else {
        this.errorDateStart = ''
      }
    },
    'end_date' () {
      if (this.end_date === 'null') {
        this.end_date = ''
      }
      if (this.start_date) {
        if (new Date(this.start_date).getTime() > new Date(this.end_date).getTime()) {
          this.errorDateStart = '開始日は終了日より前である必要があります'
        } else {
          this.errorDateStart = ''
        }
      } else {
        this.errorDateStart = ''
      }
    }
  },
  methods: {
    selectFolder () {
      if (this.idSelect) {
        if (this.folder_parent_id === '' || this.idSelect === this.folder_parent_id) {
          this.folder_parent_id = 0
          this.folder_name = 'ファイル一覧'
        } else {
          this.folder_name = this.metadataMove.folder_name
          if (this.folder_parent_id === 0) {
            this.folder_name = 'ファイル一覧'
          }
        }
      } else {
        if (this.folder_parent_id === '') {
          this.folder_parent_id = 0
          this.folder_name = 'ファイル一覧'
        } else {
          this.folder_name = this.metadataMove.folder_name
          if (this.folder_parent_id === 0) {
            this.folder_name = 'ファイル一覧'
          }
        }
      }
      this.idSelect = this.folder_parent_id
      this.$store.commit('managerFolder/CHANGE_METADATA_MOVE', '')
      this.$store.commit('managerFolder/CHANGE_FOLDER_MOVE', '')
      this.isHidden = false
    },
    openFolder (id) {
      this.folder_parent_id = id
      this.$store.dispatch('managerFolder/getFolderMove', {page_index: 1, id: id})
    },
    backFolder (id) {
      this.folder_parent_id = id
      this.$store.dispatch('managerFolder/getFolderMove', {page_index: 1, id: id})
    },
    showListFolder () {
      if (!this.isHidden) {
        this.isHidden = true
        this.$store.dispatch('managerFolder/getFolderMove', {page_index: 1, id: 0})
      } else {
        this.isHidden = false
      }
    },
    closeAutocomplete () {
      this.$refs.multiselect.$refs.search.setAttribute('autocomplete', 'off')
    },
    closeTags (index) {
      let deleteIndex = this.tag.findIndex(n => n.name === index.name)
      this.tag.splice(deleteIndex, 1)
    },
    onSelect (skill) {
      let data = null
      if (!_.isEmpty(this.tag)) {
        data = this.tag.find(n => n.name === skill)
      }
      if (_.isEmpty(this.tag) || (!_.isEmpty(this.tag) && !data)) {
        this.tag.push(skill)
      }
    },
    addTag (skill) {
      let data = null
      const tag = {
        id: 0,
        name: skill
      }
      if (!_.isEmpty(this.tag)) {
        data = this.tag.find(n => n.name === skill)
      }
      if (_.isEmpty(this.tag) || (!_.isEmpty(this.tag) && !data)) {
        this.tag.push(tag)
      }
    },
    getTag (value) {
      if (value) {
        setTimeout(() => {
          this.$store.dispatch('managerFolder/getTag', {name: value})
        }, 1000)
      } else {
        setTimeout(() => {
          this.$store.dispatch('managerFolder/getTag')
        }, 1000)
      }
    },
    hideModal () {
      this.tags = []
      this.tag = []
      this.start_date = ''
      this.end_date = ''
      this.folder_parent_id = ''
      this.media_type_ids = []
      this.author_id = ''
      this.file_name = ''
      this.isHidden = false
      this.$refs['modalUploadFile'].hide()
    },
    clearData () {
      this.tags = []
      this.tag = []
      this.start_date = ''
      this.end_date = ''
      this.folder_parent_id = ''
      this.media_type_ids = []
      this.author_id = ''
      this.file_name = ''
      this.folder_name = ''
    },
    searchFile () {
      if (this.errorDateStart) {
        return
      }
      this.tags = this.tag.map(e => e.id)
      if (this.tags.length > 0 || this.start_date || this.end_date || this.file_name || this.folder_parent_id !== '' || this.media_type_ids.length > 0 || this.author_id) {
        if (this.$route.query.tab) {
          this.$router.push({
            path: `/manager/items/search`,
            query: {tab: this.$route.query.tab, type: this.media_type_ids.join(','), begin: this.start_date, end: this.end_date, folder: this.folder_parent_id, author: this.author_id, tag: this.tags.join(','), file: this.file_name}
          })
        } else {
          this.$router.push({
            path: `/manager/items/search`,
            query: {type: this.media_type_ids.join(','), begin: this.start_date, end: this.end_date, folder: this.folder_parent_id, author: this.author_id, tag: this.tags.join(','), file: this.file_name}
          })
        }
        this.hideModal()
      } else {
        this.$refs['modalUploadFile'].hide()
      }
    }
  },
  components: {
    'b-modal': BModal,
    Multiselect
  },
  directives: {
    'b-modal': VBModal
  },
  computed: {
    ...mapState({
      listTags: state => state.managerFolder.listTags,
      folderMove: state => state.managerFolder.folderMove,
      metadataMove: state => state.managerFolder.metadataMove,
      listAuthor: state => state.managerFolder.listAuthor
    })
  },
  mounted () {
    var device = navigator.userAgent.toLowerCase()

    // add class for chrome in macos
    if (device.indexOf('chrome') > -1) {
      this.checkChrome = true
    }
    // add class for firefox in macos
    if (device.indexOf('firefox') > -1) {
      this.checkFirefox = true
    }

    setDragAndDrop(this.$refs['modalUploadFile'].$refs['content'])
  }
}
</script>

<style scoped lang="scss">
.label input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.modalUser--main ul{
  list-style: none;
}
#af {
  display: none;
}
@import '@/assets/stylesheet/vendor/uploadfile.scss';
@import "@/assets/stylesheet/vendor/detail_vendor.scss";
@import "@/assets/stylesheet/auth/listfile.scss";

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/Manager/FolderManager/SearchFile.vue